import { createBrowserRouter, Navigate, type RouterProviderProps } from 'react-router-dom';
import { AdminLayout } from './layouts/AdminLayout';
import { CreatorLayout } from './layouts/CreatorLayout';
import { CreatorBareLayout } from './layouts/CreatorBareLayout';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { DashboardPage } from './pages/admin/DashboardPage';
import { CreatorDetailPage } from './pages/admin/CreatorDetailPage';
import { CreatorLoginPage } from './pages/creator/CreatorLoginPage';
import { IntakeFormPage } from './pages/creator/IntakeFormPage';
import { CreatorHubPage } from './pages/creator/CreatorHubPage';
import { WelcomePage } from './pages/creator/WelcomePage';
import { HomeView } from './pages/creator/views/HomeView';
import { ProfileView } from './pages/creator/views/ProfileView';
import { DocumentsView } from './pages/creator/views/DocumentsView';
import { MedicalIntakeView } from './pages/creator/views/MedicalIntakeView';
import { BrandGuidelinesView } from './pages/creator/views/BrandGuidelinesView';
import { VideoSubmissionView } from './pages/creator/views/VideoSubmissionView';
import { MessagesView } from './pages/creator/views/MessagesView';
import { PaymentView } from './pages/creator/views/PaymentView';
import { NotFound } from './pages/NotFound';

// Annotate with a type nameable from react-router-dom so the declaration
// doesn't reference the transitive @remix-run/router package by path — which
// isn't portable under pnpm's isolated node_modules layout (TS2742).
export const router: RouterProviderProps['router'] = createBrowserRouter([
  { path: '/', element: <Navigate to="/creator" replace /> },
  { path: '/admin/login', element: <AdminLoginPage /> },
  { path: '/creator/login', element: <CreatorLoginPage /> },
  { path: '/apply', element: <IntakeFormPage /> },
  {
    element: <AdminLayout />,
    children: [
      { path: '/admin', element: <DashboardPage /> },
      { path: '/admin/creators/:id', element: <CreatorDetailPage /> },
    ],
  },
  {
    element: <CreatorBareLayout />,
    children: [{ path: '/creator/welcome', element: <WelcomePage /> }],
  },
  {
    element: <CreatorLayout />,
    children: [
      {
        path: '/creator',
        element: <CreatorHubPage />,
        children: [
          { index: true, element: <HomeView /> },
          { path: 'profile', element: <ProfileView /> },
          { path: 'documents', element: <DocumentsView /> },
          { path: 'contract', element: <Navigate to="/creator/documents" replace /> },
          { path: 'medical', element: <MedicalIntakeView /> },
          { path: 'guidelines', element: <BrandGuidelinesView /> },
          { path: 'video', element: <VideoSubmissionView /> },
          { path: 'messages', element: <MessagesView /> },
          { path: 'payment', element: <PaymentView /> },
        ],
      },
    ],
  },
  { path: '*', element: <NotFound /> },
]);
